import ArrowDownwardOutlinedIcon from '@mui/icons-material/ArrowDownwardOutlined';
import ArrowUpwardOutlinedIcon from '@mui/icons-material/ArrowUpwardOutlined';
import { Box, Paper } from '@mui/material';
import React from 'react';
import { themeColors } from '../../JuvareTheme';
import { tabStyle } from '../utils/tabStyle';
import { GlobalTabLabel } from './GlobalTabLabel';
/**
 * Displays a visual drag overlay when a tab is being dragged for reordering.
 * Includes a floating tab preview and directional arrows to indicate the target drop location.
 *
 * @param {ReorderDragOverlayProps} root0 - Props object.
 * @param {Point} [root0.dragPoint] - The current pointer position while dragging.
 * @param {Point} [root0.dragOffset] - The offset between the pointer and the dragged element.
 * @param {DOMRect} [root0.dragMoveToRect] - The target rectangle for where the tab is being moved to.
 * @param {GlobalTab} [root0.draggedTab] - The tab that is currently being dragged.
 * @returns {JSX.Element | null} The rendered drag overlay or null if not dragging.
 */
export const ReorderDragOverlay = ({ dragPoint, dragOffset, dragMoveToRect, draggedTab }) => {
    if (dragPoint && dragOffset && draggedTab) {
        return (React.createElement(Box, { sx: {
                position: 'fixed',
                top: 0,
                left: 0,
                bottom: 0,
                right: 0,
                zIndex: (theme) => theme.zIndex.tooltip + 100,
                pointerEvents: 'none',
            } },
            React.createElement(Paper, { sx: Object.assign({ position: 'absolute', left: dragPoint.x - dragOffset.x, top: dragPoint.y - dragOffset.y, backgroundColor: themeColors.primary.surface, fontSize: (theme) => theme.typography.body2.fontSize }, tabStyle), elevation: 6 },
                React.createElement(GlobalTabLabel, { tabs: [], tab: draggedTab })),
            dragMoveToRect && (React.createElement(Box, { sx: {
                    position: 'absolute',
                    left: dragMoveToRect.x - 7,
                    top: dragMoveToRect.y - 8,
                    display: 'flex',
                    flexDirection: 'column',
                    pointerEvents: 'none',
                    color: themeColors.accent.green.bold,
                } },
                React.createElement(ArrowDownwardOutlinedIcon, null),
                React.createElement("div", { style: { height: 16 } }),
                React.createElement(ArrowUpwardOutlinedIcon, null)))));
    }
    else {
        return null;
    }
};
